/* eslint-disable react/prop-types */
import React from "react";
import { Row, Col } from "react-bootstrap";
// Common
import ClassCapacityWarning from "../../common/ClassCapacityWarning";
import FadeIn from "../../common/FadeIn";
import ReturnButton from "../../common/ReturnButton";
//TimeRendering
import Moment from "react-moment";

const BlockInfo = (props) => {
  const currencySymbol = props.currencySymbol;
  const blockData = props.blockData;
  const displayPrice = props.displayPrice;
  return (
    <FadeIn delay={250} duration={450}>
      <Row>
        <Col>
          <ReturnButton direction={props.direction} />
          <div className='shadow mt-4 p-3 border'>
            <h1>{blockData.LessonType}</h1>
            <ClassCapacityWarning
              SubscribersNumber={blockData.Subscribers_Number}
              Capacity={blockData.MaxLearners}
            />

            <h4>{currencySymbol + parseFloat(displayPrice).toFixed(2)}</h4>
            {blockData.Prorate && (
              <small>
                <h6>After calculating for dates already passed.</h6>
              </small>
            )}
            <hr />
            <p>
              <em>{blockData.ShortDescription}</em>
            </p>
            <hr />
            <p>
              The intended age group is:{" "}
              {blockData.LowerAgeString + " - " + blockData.UpperAgeString + "."}
            </p>
            <hr />
            {blockData.Tutor !== undefined && (
              <>
                <p>The tutor is: {blockData.Tutor.First_Name}</p>
                <hr />
              </>
            )}
            <p>
              The session will be held at: {blockData.Venue.VenueName},{" "}
              {blockData.Venue.VenueAddress}
            </p>
            {blockData.Venue.Note && (
              <>
                {" "}
                <hr />
                <p>Venue Note: {blockData.Venue.Note}</p>
              </>
            )}
            <hr />
            <p>
              <h5>Dates &amp; Start Times</h5>
              {blockData.Dates.map((date, index) => (
                <span
                  className='me-2 text-center shadow border p-1 mt-1 d-block d-md-inline-block'
                  key={index}
                >
                  <Moment format='ddd DD MMMM, h:mm A'>{date}</Moment>
                </span>
              ))}
              <br />
              <small className='mt-2'>
                The sessions will last for {blockData.Duration} minutes.
              </small>
              <br />
              <small>
                The next date is{" "}
                <Moment format='ddd DD MMMM, h:mm A'>{blockData.forwardDates[0]}</Moment>
              </small>
            </p>
          </div>
        </Col>
      </Row>
    </FadeIn>
  );
};

export default BlockInfo;
